import images from "../assets/img/images";
import { EVENT_GROUP_ATTR } from "../constants/eventGroups";

const driveInOutFields = {
  fields: [
    {
      name: "main",
      subFieldsId: 0,
      collapsedNb: 6,
      img: images.main,
    },
    {
      name: "driver",
      subFieldsId: 1,
      collapsedNb: 2,
      img: images.humanIconBlack,
    },
    {
      name: "truck",
      subFieldsId: 2,
      collapsedNb: 3,
      img: images.truckIconBlack,
    },
    {
      name: "trailer1",
      subFieldsId: 3,
      collapsedNb: 2,
      img: images.trailerIconBlack,
    },
    {
      name: "trailer2",
      subFieldsId: 3,
      collapsedNb: 2,
      img: images.trailerIconBlack,
    },
    {
      name: "container1",
      subFieldsId: 3,
      collapsedNb: 2,
      img: images.containerIconBlack,
    },
    {
      name: "container2",
      subFieldsId: 3,
      collapsedNb: 2,
      img: images.containerIconBlack,
    },
    {
      name: "main",
      subFieldsId: 4,
    },
  ],
  subFields: {
    0: [
      {
        name: "ref",
        filterType: "search",
        minWidth: "120px",
      },
      {
        name: "tailgating",
        filterType: "select",
        type: "boolean",
        minWidth: "100px",
        id: 139,
      },
      {
        name: "dateTime",
        filterType: "date",
        minWidth: "150px",
      },
      {
        name: "zone",
        filterType: "select",
      },
      {
        name: "status",
        filterType: "select",
      },
      {
        name: "comments",
        filterType: "search",
        minWidth: "200px",
      },
      {
        name: "riskLevel",
        filterType: "select",
        type: "lov",
      },
      {
        name: "logType",
        filterType: "select",
      },
      {
        name: "entryStatus",
        filterType: "select",
        type: "lov",
        id: 105,
      },
      {
        name: "processedBy",
        filterType: "search",
      },
      {
        name: "modifiedOn",
        filterType: "date",
      },
      {
        name: "carrier",
        filterType: "select",
        type: "lov",
        id: 89,
      },
      {
        name: "active",
        filterType: "select",
        type: "lov",
      },
    ],
    1: [
      {
        name: "captured",
        minWidth: "100px",
        csv: false,
      },
      {
        name: "name",
        filterType: "search",
        minWidth: "250px",
      },
      {
        name: "tag",
        filterType: "select",
      },
      {
        name: "threatLevel",
        filterType: "select",
      },
    ],
    2: [
      {
        name: "captured",
        minWidth: "100px",
        csv: false,
      },
      {
        name: "privateVehicle",
        filterType: "select",
        type: "lov",
        id: 106,
      },
      {
        name: "name",
        filterType: "search",
        minWidth: "250px",
      },
      {
        name: "loaded",
        filterType: "select",
        type: "lov",
        id: 108,
      },
      {
        name: "po",
        filterType: "search",
      },
      {
        name: "bol",
        filterType: "search",
      },
      {
        name: "product",
        filterType: "search",
      },
      {
        name: "verified",
        filterType: "select",
        csv: false,
      },
    ],
    3: [
      {
        name: "captured",
        minWidth: "100px",
        csv: false,
      },
      {
        name: "name",
        filterType: "search",
        minWidth: "250px",
      },
      {
        name: "loaded",
        filterType: "select",
      },
      {
        name: "po",
        filterType: "search",
      },
      {
        name: "bol",
        filterType: "search",
      },
      {
        name: "product",
        filterType: "search",
      },
      {
        name: "verified",
        filterType: "select",
        csv: false,
      },
    ],
    // NOT DISPLAYED
    4: [
      {
        name: "tempType",
        type: "lov",
        id: 88,
      },
      {
        name: "vehicleType",
        type: "lov",
        id: 42,
      },
      {
        name: "trailerType",
        type: "lov",
        id: 53,
      },
    ],
  },
  verified: [
    {
      name: "fuelLevel",
      filterType: "select",
      type: "lov",
      id: 79,
      img: images.fuelIcon,
    },
    {
      name: "odometer",
      filterType: "search",
      img: images.odometerIcon,
    },
    {
      name: "seal",
      filterType: "search",
      img: images.sealIcon,
    },
    {
      name: "tempFront",
      filterType: "none",
      img: images.temperatureIcon,
    },
    {
      name: "tempMiddle",
      filterType: "none",
      img: images.temperatureIcon,
    },
    {
      name: "tempBack",
      filterType: "none",
      img: images.temperatureIcon,
    },
    {
      name: "comments",
      filterType: "search",
    },
  ],
  shortSubFields: {
    0: [
      {
        name: "ref",
        filterType: "search",
        minWidth: "90px",
      },
      {
        name: "tailgating",
        filterType: "select",
        type: "boolean",
        minWidth: "90px",
        id: 139,
      },
      {
        name: "dateTime",
        filterType: "date",
        minWidth: "130px",
      },
      {
        name: "entryStatus",
        filterType: "select",
        type: "lov",
        id: 105,
      },
    ],
    1: [
      {
        name: "captured",
        minWidth: "135px",
      },
      {
        name: "name",
        filterType: "search",
        minWidth: "240px",
      },
    ],
    2: [
      {
        name: "captured",
        minWidth: "135px",
      },
      {
        name: "privateVehicle",
        filterType: "select",
        type: "lov",
        minWidth: "90px",
        id: 106,
      },
      {
        name: "name",
        filterType: "search",
        minWidth: "240px",
      },
    ],
    3: [
      {
        name: "captured",
        minWidth: "135px",
      },
      {
        name: "name",
        filterType: "search",
        minWidth: "240px",
      },
    ],
    4: [
      {
        name: "status",
        filterType: "select",
      },
      {
        name: "comments",
        filterType: "search",
        minWidth: "300px",
      },
    ],
  },
};

const walkInOutFields = {
  fields: [
    {
      name: "main",
      subFieldsId: 0,
      collapsedNb: 5,
      img: images.main,
    },
    {
      name: "human",
      subFieldsId: 1,
      collapsedNb: 3,
      img: images.humanIconBlack,
    },
    {
      name: "main",
      subFieldsId: 2,
    },
  ],
  subFields: {
    0: [
      {
        name: "ref",
        filterType: "search",
        minWidth: "120px",
      },
      {
        name: "dateTime",
        filterType: "date",
        minWidth: "150px",
      },
      {
        name: "zone",
        filterType: "select",
      },
      {
        name: "status",
        filterType: "select",
      },
      {
        name: "comments",
        filterType: "search",
        minWidth: "200px",
      },
      {
        name: "riskLevel",
        filterType: "select",
        type: "lov",
      },
      {
        name: "logType",
        filterType: "select",
      },
      {
        name: "entryStatus",
        filterType: "select",
        type: "lov",
        id: 105,
      },
      {
        name: "processedBy",
        filterType: "search",
      },
      {
        name: "modifiedOn",
        filterType: "date",
      },
      {
        name: "active",
        filterType: "select",
        type: "lov",
      },
    ],
    1: [
      {
        name: "captured",
        minWidth: "135px",
        csv: false,
      },
      {
        name: "name",
        filterType: "search",
        minWidth: "240px",
      },
      {
        name: "tag",
      },
      {
        name: "threatLevel",
        filterType: "select",
      },
      {
        name: "verification",
        minWidth: "320px",
      },
      {
        name: "instruction",
        minWidth: "250px",
        type: "lov",
        id: 158,
      },
      {
        name: "mask",
        minWidth: "50px",
      },
      {
        name: "temperature",
        minWidth: "50px",
      },
    ],
    2: [
      {
        name: "status",
        filterType: "select",
      },
      {
        name: "comments",
        filterType: "search",
      },
    ],
  },
  verified: [],
  shortSubFields: {
    0: [
      {
        name: "ref",
        filterType: "search",
        minWidth: "90px",
      },
      {
        name: "dateTime",
        filterType: "date",
        minWidth: "130px",
      },
      {
        name: "entryStatus",
        filterType: "select",
        type: "lov",
        id: 105,
      },
    ],
    1: [
      {
        name: "captured",
        minWidth: "135px",
      },
      {
        name: "name",
        filterType: "search",
        minWidth: "240px",
      },
      {
        name: "tag",
      },
      {
        name: "verification",
        minWidth: "210px",
      },
      {
        name: "instruction",
        minWidth: "250px",
        type: "lov",
        id: 158,
      },
      {
        name: "mask",
        minWidth: "50px",
      },
      {
        name: "temperature",
        minWidth: "50px",
      },
    ],
    2: [
      {
        name: "status",
        filterType: "select",
      },
      {
        name: "comments",
        filterType: "search",
        minWidth: "300px",
      },
    ],
  },
};

const trainInOutFields = {
  fields: [
    {
      name: "main",
      subFieldsId: 0,
      collapsedNb: 6,
      img: images.main,
    },
    {
      name: "main",
      subFieldsId: 1,
    },
  ],
  subFields: {
    0: [
      {
        name: "ref",
        filterType: "search",
        minWidth: "120px",
      },
      {
        name: "dateTime",
        filterType: "date",
        minWidth: "150px",
      },
      {
        name: "zone",
        filterType: "select",
      },
      {
        name: "status",
        filterType: "select",
      },
      {
        name: "railDetectionType",
        filterType: "select",
        type: "lov",
        id: EVENT_GROUP_ATTR.RAIL_DETECTION_TYPE,
      },
      {
        name: "trainId",
        filterType: "search",
      },
      {
        name: "yardEventType",
        filterType: "select",
        type: "lov",
        id: EVENT_GROUP_ATTR.YARD_EVENT_TYPE,
      },
      {
        name: "riskLevel",
        filterType: "select",
        type: "lov",
      },
      {
        name: "comments",
        filterType: "search",
        minWidth: "200px",
      },
      {
        name: "modifiedOn",
        filterType: "date",
      },
      {
        name: "active",
        filterType: "select",
        type: "lov",
      },
    ],
    // NOT DISPLAYED
    1: [
      {
        name: "tempType",
        type: "lov",
        id: 88,
      },
      {
        name: "vehicleType",
        type: "lov",
        id: 42,
      },
      {
        name: "trailerType",
        type: "lov",
        id: 53,
      },
    ],
  },
  verified: [
  ],
  shortSubFields: {
    0: [
      {
        name: "ref",
        filterType: "search",
        minWidth: "90px",
      },
      {
        name: "dateTime",
        filterType: "date",
        minWidth: "130px",
      },
      {
        name: "entryStatus",
        filterType: "select",
        type: "lov",
        id: 105,
      },
    ],
  },
};

export { driveInOutFields, walkInOutFields, trainInOutFields };
